import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { TableModule } from 'primeng/table';
import { Messages } from '../../../common/constants/messages';
import { VoucherResponse } from '../../models/voucher-response';
import { CompanyService } from '../../services/company.service';
import { VoucherProgramService } from '../../services/voucher-program.service';
import { DialogModule } from 'primeng/dialog';
import { RoleCodeEnum } from '../../../common/enums/role-code.enum';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { HeaderService } from '../../services/header.service';
import { HttpClient } from '@angular/common/http';
import { finalize } from 'rxjs';
// import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-voucher-list',
  imports: [TableModule, CommonModule, NgxSpinnerModule, DialogModule, RouterModule],
  templateUrl: './voucher-list.component.html',
  styleUrl: './voucher-list.component.css'
})
export class VoucherListComponent implements OnInit {

  voucherList: VoucherResponse[] = [];
  agreementList: VoucherResponse[] = [];
  loading = true;
  isLoading = false;
  companyId: string | null = '';
  locListModalDlg = false;
  dialogSummary = '';
  dialogMsg = '';
  roleCode: string = '';
  confirmDeleteDialog = false;
  selectedAgreement: VoucherResponse | null = null;

  constructor(
    private companyService: CompanyService,
    private ngx: NgxSpinnerService,
    private voucherProgramService: VoucherProgramService,
    private route: ActivatedRoute,
    // private msalService: MsalService,       
    private http: HttpClient,
    private router: Router,
    private headerService: HeaderService
  ) {
  }

  ngOnInit(): void {
    this.companyId = sessionStorage.getItem('companyId') || '';
    this.roleCode = sessionStorage.getItem('roleCode') || '';
    if (this.companyId == '') {
      this.companyId = this.route.snapshot.paramMap.get('id');
      if (this.companyId) {
        this.verifyToken();
      }
      else {
        this.router.navigate(['/login']);
      }
    }
    else {
      this.getVoucherList(this.companyId);
    }
  }

  verifyToken() {
    let companyName = sessionStorage.getItem('companyName');
    if (companyName) {
      this.headerService.setCompanyName(companyName);
      this.getVoucherList(this.companyId);
    }
    else {
      const returnUrl = this.router.url;
      console.log(returnUrl);
      this.router.navigate(
        ['/login'],
        {
          queryParams: {
            returnUrl: returnUrl
          }
        }
      );
    }
  }

  getVoucherList(id: string | null): void {
    this.ngx.show();
    this.isLoading = true;

    this.companyService.getAllVouchers(id || '')
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.ngx.hide();
        })
      )
      .subscribe({
        next: (data) => {
          this.voucherList = (data || [])
            .filter(v => v.fileType !== null && v.fileType !== 'Agreement')
            .sort((a, b) =>
              new Date(b.createdDate).getTime() -
              new Date(a.createdDate).getTime()
            );

          this.agreementList = (data || [])
            .filter(v => v.fileType === 'Agreement')
            .sort((a, b) =>
              new Date(b.createdDate).getTime() -
              new Date(a.createdDate).getTime()
            )
            .map(v => ({
              ...v,
              fileType: 'Voucher'
            }));
        },
        error: (err) => {
          console.error('Failed to load vouchers and agreements', err);

          this.dialogSummary = Messages.ErrorTitle;
          this.dialogMsg = 'Unable to refresh the voucher and agreement lists.';
          this.locListModalDlg = true;
        }
      });
  }

  isSuperAdmin(): boolean {
    return Number(this.roleCode) === RoleCodeEnum.SuperAdmin;
  }

  downloadFile(fileName: string, fileType: string) {

    // let containerType = "3";
    // // switch(fileType)
    // // {
    // //   case "Agreement":
    // //     containerType = "1";
    // //     break;
    // //   case "Flu":
    // //     containerType = "2";
    // //     break;
    // //   default:
    // //     containerType = "3";
    // //     break;
    // // }

    const payload = {
      fileName: fileName,
      containerType: fileType
    }

    this.ngx.show();
    this.isLoading = true;

    this.companyService.downloadFile(payload)
      .subscribe(
        {
          next: (blob) => {
            this.ngx.hide();
            this.isLoading = false;
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
          },

          error: (err) => {
            this.ngx.hide();
            this.isLoading = false;
            this.dialogSummary = Messages.ErrorTitle;
            this.dialogMsg = "Download Failed";
            this.locListModalDlg = true;
          }
        });
  }

  okClicked(): void {
    this.locListModalDlg = false;

    // Reload voucher and agreement grids with spinner
    this.getVoucherList(this.companyId);
  }

  getStatusLabel(status: string): string {
    const statusMap: { [key: string]: string } = {
      PendingW9: 'W-9 Review',
      Completed: 'Completed',
      Generating: 'Generating',
      Available: 'Available',
      Error: 'Error',
      Expired: 'Expired',
      W9Rejected: 'W-9 Rejected'
    };

    return statusMap[status] || status;
  }

  openFile(fileName: string, fileType: string) {
    let containerType = "3";

    // Optional: Adjust container type based on file type
    // switch (fileType) {
    //   case "Agreement":
    //     containerType = "1";
    //     break;
    //   case "Flu":
    //   case "Routine":
    //     containerType = "2";
    //     break;
    //   default:
    //     containerType = "3";
    // }

    const payload = {
      fileName: fileName,
      containerType: containerType
    };

    this.ngx.show();
    this.isLoading = true;

    this.companyService.downloadFile(payload).subscribe({
      next: () => {
        this.ngx.hide();
        this.isLoading = false;

        this.confirmDeleteDialog = false;

        this.dialogSummary = 'Success';
        this.dialogMsg =
          'The agreement and associated vouchers have been deleted successfully!';

        this.locListModalDlg = true;
      },
      error: () => {
        this.ngx.hide();
        this.isLoading = false;
        this.dialogSummary = Messages.ErrorTitle;
        this.dialogMsg = "Unable to open the file.";
        this.locListModalDlg = true;
      }
    });
  }

  confirmDelete(voucher: VoucherResponse) {
    this.selectedAgreement = voucher;
    this.confirmDeleteDialog = true;
  }

  deleteAgreement(): void {
    if (!this.selectedAgreement) {
      return;
    }

    this.ngx.show();
    this.isLoading = true;

    this.voucherProgramService
      .deleteVoucherProgram(this.selectedAgreement.voucherProgramId || 0)
      .subscribe({
        next: () => {
          this.ngx.hide();
          this.isLoading = false;

          // Close the delete confirmation dialog
          this.confirmDeleteDialog = false;

          // Display success message
          this.dialogSummary = 'Success';
          this.dialogMsg =
            'The agreement and associated vouchers have been deleted successfully!';

          // Open success dialog
          this.locListModalDlg = true;
        },
        error: (err) => {
          console.error('Delete failed', err);

          this.ngx.hide();
          this.isLoading = false;

          // Close the delete confirmation dialog
          this.confirmDeleteDialog = false;

          // Display error message
          this.dialogSummary = Messages.ErrorTitle;
          this.dialogMsg =
            'Failed to delete the agreement and associated vouchers. Please try again.';

          this.locListModalDlg = true;
        }
      });
  }
}
